import React from "react";
import { TextInput, required, minValue, maxValue, SelectInput } from "react-admin";
import { Grid, InputAdornment } from "@mui/material";
import { numberValidator, onlyDigits } from "utils/validations";
import { MoneyInput } from "server/components/Fields/MoneyInput";
import { MonthsOfTheYear } from "utils/choices";

const SaveForm = ({ isCreating }) => {
  return (
    <Grid
      container
      spacing={2}
    >
      <Grid
        item
        xs={12}
        md={3}
      >
        <TextInput
          label="От година"
          source="year"
          disabled={!isCreating}
          validate={[required(), onlyDigits, minValue(2000, "Минимална година 2000г.")]}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={3}
      >
        <SelectInput
          label="От месец"
          source="month"
          choices={MonthsOfTheYear}
          disabled={!isCreating}
          validate={required()}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={3}
      >
        <MoneyInput
          type="double"
          label="Стойност"
          source="amount"
          validate={required()}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={3}
      >
        <TextInput
          type="double"
          label="Процент"
          source="percentage"
          validate={[
            required(),
            numberValidator,
            minValue(0, "Минимална стойност 0"),
            maxValue(100, "Максимална стойност 100"),
          ]}
          InputProps={{
            endAdornment: <InputAdornment position="end">%</InputAdornment>,
          }}
        />
      </Grid>
    </Grid>
  );
};

export default SaveForm;
